import React, { Suspense } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {
  Switch,
  Route,
  NavLink,
  useLocation
} from "react-router-dom";

import {
    Paper,
    Tabs,
    Tab,
    Container
} from '@material-ui/core';

const VideoPage =  React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "video-page" */ './VideoPage'));
const DocumentPage =  React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "document-page" */ './DocumentsPage'));
const BlogPage =  React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "blog-page" */ './BlogPage'));

const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    container: {
        padding: "24px",
    },
    link: {
        '&:focus, &:hover': {
            outline: "none",
            textUnderline: "none"
        }
    }
  });

function PageNav({navigate, ...props}) {
    return <Tab {...props}/>
}

function ResourcePortalIndex(props) {
    const classes = useStyles();
    let location = useLocation();

    return <>
    <Container>
        <Paper className={classes.root}>
            <Tabs
                value={location.pathname}
                indicatorColor="primary"
                textColor="primary"
                centered>
                
                <NavLink label="Documents" 
                         className={classes.link} 
                         component={PageNav} 
                         to="/" 
                         value="/"/>

                <NavLink label="Blog" 
                         className={classes.link} 
                         component={PageNav} 
                         to="/blog" 
                         value="/blog"/>

                <NavLink label="Videos" 
                         className={classes.link} 
                         component={PageNav} 
                         to="/videos" 
                         value="/videos" />
            </Tabs>
        </Paper>
    </Container>
    <Suspense fallback={<div></div>}>
        <Switch>
            <Route path="/videos">
                <Container className={classes.container}>
                    <VideoPage/>
                </Container>
            </Route>

            <Route path="/blog">
                <Container className={classes.container}>
                    <BlogPage/>
                </Container>
            </Route>

            <Route path="/">
                <Container className={classes.container}>
                    <DocumentPage/>
                </Container>
            </Route>
        </Switch>
    </Suspense>
    </>
}

export default ResourcePortalIndex;